import * as React from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { UploaderStyled, ButtonsFotter } from './uploader-styled';
import { BaSeLoading, BaSeButton, BaSeTheme } from '@base/react';

const ASPECT_RATIO = 568 / 304;

function makeid(length) {
  var result = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const Uploader = ({ foto, onSave, forceClose }) => {
  const [crop, setCrop] = React.useState({
    unit: '%',
    width: 100,
    aspect: ASPECT_RATIO,
  });

  const [currentImage, setCurrentImage] = React.useState(null);
  const [croppedImage, setCroppedImage] = React.useState(null);
  const [imageType, setImageType] = React.useState('');
  const [init, setInit] = React.useState(false);

  const makeBlobFromCanvas = (canvas) => new Promise((resolve, reject) => {
    try {
      canvas.toBlob((blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error('Canvas is empty');
          return;
        }
        const image = new File([blob], makeid(12), {
          type: imageType,
        });
        blob.name = makeid(12);
        resolve(image);
      }, imageType);
    } catch (e) {
      reject(e);
    }
  });

  const onUploadStart = (image) => {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.width / ASPECT_RATIO;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(
      image,
      0,
      0,
      image.naturalWidth,
      image.naturalWidth / ASPECT_RATIO,
      0,
      0,
      canvas.width,
      canvas.height,
    );
    return makeBlobFromCanvas(canvas);
  };

  const getCroppedImg = (image, crop) => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );

    return makeBlobFromCanvas(canvas);
  };

  const makeClientCrop = async (crop) => {
    if (currentImage && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(
        currentImage,
        crop,
      );
      setCroppedImage(croppedImageUrl);
    }
  };

  const handleImageLoad = (image) => {
    const src = image?.src.split(';')[0].split('data:')[1];
    setImageType(src);
    setCurrentImage(image);
    onUploadStart(image)
      .then((data) => setCroppedImage(data))
      .catch((error) => console.log(error, 'error'));
  };

  const handleSave = (im) => {
    onSave(im);
    // eslint-disable-next-line no-unused-expressions
    forceClose?.closeModal();
  };

  const handleCrop = (val) => {
    setCrop(val);
    if (!init) {
      makeClientCrop(val);
      setInit(true);
    }
  };

  return (
    <>
      {foto && (
        <UploaderStyled width={currentImage?.width}>
          <ReactCrop
            src={foto}
            crop={crop}
            ruleOfThirds
            onChange={(val) => handleCrop(val)}
            onComplete={(val) => makeClientCrop(val)}
            onImageLoaded={(image) => handleImageLoad(image)}
          />
        </UploaderStyled>
      )}
      {!foto && <BaSeLoading />}
      <ButtonsFotter>
        <BaSeButton value="Salvar" onClick={() => handleSave(croppedImage)} />
        <BaSeButton
          value="Cancelar"
          color={BaSeTheme.colors.institucionais.azulSebrae36}
          type="secondary"
          onClick={() => forceClose?.closeModal()}
        />
      </ButtonsFotter>
    </>
  );
};
